import type {FontWeight} from "../types";

export const fontWeight: FontWeight = {
    light: "300" as const,
    regular: "400" as const, // also called normal
    medium: "500" as const,
    semibold: "600" as const,
    bold: "700" as const,
};
